const ITEM_PATHNAME = "pathname";

class SessionStorage {
	private location!: Location;
	public setLocation(location: Location) {
		window.sessionStorage.setItem(ITEM_PATHNAME, location.pathname);
	}

	public setHomeLocation(location: Location) {
		window.sessionStorage.setItem(ITEM_PATHNAME, `/${location.pathname.split("/")[1]}/home`);
	}

	public getLocation() {
		if (this.location) {
			return this.location.pathname;
		}
		const currentLocation = window.sessionStorage.getItem(ITEM_PATHNAME);
		return currentLocation ? currentLocation : "/home";
	}
}

export default new SessionStorage();